import {
  css,
  Divider as MuiDivider,
  dividerClasses,
  dividerClasses as muiDividerClasses,
  styled,
} from '@mui/material';

import type { DividerProps } from './types';

function Divider(props: DividerProps) {
  return <DividerRoot {...props} />;
}

Divider.displayName = 'Divider';

// Styled Components - theme.ts에서 이전된 스타일
const DividerRoot = styled(MuiDivider, {
  shouldForwardProp: prop => !['margin', 'thickness'].includes(prop as string),
})<DividerProps>(
  ({ margin = 0, thickness = 1, orientation = 'horizontal' }) => css`
    /* theme.ts에서 이전된 root 스타일 */
    border-color: #ebeef2;

    &::before,
    &::after {
      border-color: #ebeef2;
    }

    /* theme.ts에서 이전된 wrapper 스타일 */
    & .${muiDividerClasses.wrapper} {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    /* orientation별 스타일 */
    ${getOrientationStyles(orientation, { margin, thickness })}
  `,
);

// Helper 함수: orientation에 따른 스타일 반환
function getOrientationStyles(
  orientation: DividerProps['orientation'],
  { margin, thickness }: Pick<DividerProps, 'margin' | 'thickness'>,
) {
  if (orientation === 'horizontal') {
    return css`
      &:not(.${dividerClasses.withChildren}) {
        border-bottom-width: ${thickness}px;
        margin-top: ${margin}px;
        margin-bottom: ${margin}px;
      }

      &.${dividerClasses.withChildren} {
        &::before,
        &::after {
          border-top-width: ${thickness}px;
          margin-top: ${margin}px;
          margin-bottom: ${margin}px;
        }
      }
    `;
  }

  // vertical
  return css`
    &:not(.${dividerClasses.withChildren}) {
      border-right-width: ${thickness}px;
      margin-left: ${margin}px;
      margin-right: ${margin}px;
    }

    &.${dividerClasses.withChildren} {
      &::before,
      &::after {
        border-left-width: ${thickness}px;
        margin-left: ${margin}px;
        margin-right: ${margin}px;
      }
    }
  `;
}

export default Divider;
